export * from './terms-conditions-page.component';
